import * as React from "react";
import * as ReactDOM from "react-dom";
import { Map } from "immutable";
import { IOWidget, Pair, mk_pair, Sum, inl, inr, mk_widget } from "../widget";

export interface AllProps<i,o> {
  input:i
  widgets:IOWidget<i,o>[]
  on_done:(output:o[]) => void
}
export interface AllState<i,o> {
  outputs:Map<number,o>
}
export class All<i,o> extends React.Component<AllProps<i,o>, AllState<i,o>> {
  constructor(props:AllProps<i,o>, context:any) {
    super(props, context)

    this.state = { outputs:Map() }
  }

  render() {
    return <>
      {this.props.widgets.map((widget,i) =>
        widget(this.props.input).run(output =>
          this.setState(s => ({...s, outputs:s.outputs.set(i,output)}), () => {
            let results = Array<o>(this.props.widgets.length)
            let result_set = Array<boolean>(this.props.widgets.length)
            let num_results = 0
            for (let i = 0; i < result_set.length; i++) result_set[i] = false
            this.state.outputs.forEach((o,o_i) => {
              if (o && o_i) {
                results[o_i] = o
                if (!result_set[o_i]) num_results = num_results + 1
                result_set[o_i] = true
              }
            })
            if (num_results == this.props.widgets.length) this.props.on_done(results)
          })),
      )}
    </>
  }
}

export let all = function<i,o>(widgets:IOWidget<i,o>[]) :
  IOWidget<i,o[]> {
  return (input:i) => mk_widget({
    run:(on_done:(outputs:o[]) => void) =>
      React.createElement<AllProps<i,o>>(All, { on_done, widgets, input })
  })
}
